export const dataApiUrl = 'https://voltasolar-dev.outsystemsenterprise.com/ProposalGeneration_CS/rest/PriceOffer/Resi'
export const contactApiUrl = 'https://voltasolar-dev.outsystemsenterprise.com/ProposalGeneration_CS/rest/PriceOffer/ResiContact'
export const propsalIdParamName = 'proposal_id'
export const contentApiUrl = 'https://v3-admin.volta.layerbrandingltd.com/wp-json/offer/v1/data'